import React from 'react'
import Layout from '../components/Layout'
import RichText from '../components/RichText'

function ArticleCard({ title, description, link }) {
  return (
    <article className="bg-gray-100 rounded p-4 mb-4">
      <h4 className="text-brand-dark font-semibold mb-2">{title}</h4>
      <RichText content={description} className="text-gray-700 text-justify mb-2" />
      <p className="text-right">
        {link ? (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="font-bold text-brand-dark hover:text-brand-light transition-colors"
          >
            ver mais
          </a>
        ) : (
          <span className="font-bold text-gray-500">ver mais (link indisponível)</span>
        )}
      </p>
    </article>
  )
}

export default function Imprensa({ title, content, pressArticles = [] }) {
  return (
    <Layout>
      <div className="bg-brand-bg min-h-screen py-8">
        <div className="container mx-auto px-4">
          <div className="flex items-center mb-8">
            <h3 className="text-brand-light font-bold uppercase text-xl">{title}</h3>
            <hr className="flex-1 ml-4 border-0 h-[1px] bg-brand-light" />
          </div>

          <RichText content={content} className="text-justify mb-6" />

          <div className="space-y-4">
            {pressArticles.map((article, index) => (
              <ArticleCard key={index} {...article} />
            ))}
          </div>
        </div>
      </div>
    </Layout>
  )
}
